import styles from './StaffListTable.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import Dynamic from '../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import Action from '../../components/Action/Action';
import { useNavigate } from 'react-router';

const data = [
  {
    _id: 'gnswkgnseknsg1',
    staffName: 'xtejkew4',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    actionOptions: ['Edit', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg2',
    staffName: 'xteepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    actionOptions: ['Edit', 'Delete'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
];

function StaffList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        staffName: (
          <LogoWithName
            name={item.staffName}
            onClick={() => {
              navigate('profile');
            }}
            style={{ cursor: 'pointer' }}
          />
        ),
        contact: item.contact,
        emailId: item.emailId,
        room: item.Room.join(' , '),
        status: <Dropdown label="Active" options={['Active', 'In Active']} />,
        action: (
          <Action
            key={item._id}
            options={item.actionOptions || ['Edit', 'Delete']}
            onSelect={(opt) => {
              console.log(`Selected "${opt}" for ${item.staffName}`);
              if (opt === 'Edit') {
                dispatch(openModal('addStaff'));
              } else if (opt === 'Delete') {
                dispatch(openModal('delete'));
              }
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Staff Name', accessor: 'staffName' },
    { title: 'Contact', accessor: 'contact' },
    { title: 'Email ID', accessor: 'emailId' },
    { title: 'Room', accessor: 'room' },
    { title: 'Status', accessor: 'status' },
    { title: 'Action', accessor: 'action' },
  ];

  return (
    <div className={styles.headerContainer}>
      {/* Status boxes */}

      {/* Search and Filters */}
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Staff"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <Dropdown
              label="Room"
              options={['Room1', 'Room2']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Group"
              options={['Group 1', 'Group 2']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Program"
              options={['Annual Day', 'Freshers']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />

            <IoMdTrash
              size={26}
              style={{
                marginTop: '0.5rem',
                opacity: 0.4,
                color: 'var(--Black_Color)',
                cursor: 'pointer',
              }}
              onClick={() => {
                dispatch(openModal('delete'));
              }}
            />
          </div>
        </div>

        {/* Student Data Table */}
        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default StaffList;
